import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import ViewRendererMixin from '@/helpers/vue_mixins/ViewRendererMixin';
import ActionButton from '@/components/action_button/Index.vue';
import OrangeThemeMixin from '@/helpers/vue_mixins/v2/OrangeThemeMixin';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import SearchMixin from '@/helpers/vue_mixins/v2/SearchMixin';
import ShowSearchBarMixin from '@/helpers/vue_mixins/v2/ShowSearchBarMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import VisibleCategoriesCount from '@/components/v2/VisibleCategoriesCount';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
/**
 * Base Component for managing grid and list view
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.18}
 */
let BaseViewManager = class BaseViewManager extends Mixins(Mixins(OrangeThemeMixin, ViewRendererMixin, ShowSearchBarMixin, SearchMixin, ViewportSizeMixin), RouterParamsAppMixin, CleverTapEventsMixin) {
    get categoryTemplate() {
        if (this.selectedComponentLayoutOptions.name === 'grid') {
            return this.listView;
        }
        return this.gridView;
    }
    startProductCategoryCreate() {
        this.productCategoryAction('START CREATE');
    }
    mounted() {
        const vm = this;
        if (vm.title) {
            const title = `${vm.title.toLowerCase()}_search_cursor`;
            const searchValue = JSON.parse(localStorage.getItem(title));
            vm.$refs.search.setValue(searchValue);
            this.search = searchValue;
        }
        this.viewProductCategoriesPage();
    }
};
__decorate([
    Prop({ type: String, required: false })
], BaseViewManager.prototype, "createRoutePath", void 0);
__decorate([
    Prop({ type: String, required: false })
], BaseViewManager.prototype, "editRouteName", void 0);
__decorate([
    Prop({ type: String, required: false })
], BaseViewManager.prototype, "detailsRouteName", void 0);
__decorate([
    Prop({ type: Function, required: false })
], BaseViewManager.prototype, "gridView", void 0);
__decorate([
    Prop({ type: Function, required: false })
], BaseViewManager.prototype, "listView", void 0);
BaseViewManager = __decorate([
    Component({
        components: {
            ActionButton,
            BaseSearchInput,
            VisibleCategoriesCount,
        },
    })
], BaseViewManager);
export default BaseViewManager;
